import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const fetchSuggestedApi = async (id, contentType, phoneId) => {
  const academyApiUrl = await getParam('academyApiUrl')
  return fetchGet(`${academyApiUrl}related/${contentType}/${id}`, { phoneId })
}
